import { computed, shallowRef } from 'vue'
import type { Ref } from 'vue'

type Translate = (key: string) => string

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export function isValidEmailAddress(value: string) {
  return EMAIL_PATTERN.test(value.trim())
}

export function useAuthEmailValidation(email: Ref<string>, t: Translate) {
  const isTouched = shallowRef(false)
  const wasSubmitted = shallowRef(false)
  const normalizedEmail = computed(() => email.value.trim())
  const emailError = computed(() => {
    if (!normalizedEmail.value) return isTouched.value || wasSubmitted.value ? t('auth.validation.emailRequired') : undefined
    if (!isValidEmailAddress(normalizedEmail.value)) return t('auth.validation.emailInvalid')
    return undefined
  })

  function markEmailTouched() {
    isTouched.value = true
  }

  function validateEmailBeforeSubmit() {
    isTouched.value = true
    wasSubmitted.value = true
    return !emailError.value
  }

  return {
    emailError,
    normalizedEmail,
    markEmailTouched,
    validateEmailBeforeSubmit
  }
}

export function useAuthRequiredValidation(value: Ref<string>, t: Translate, messageKey: string) {
  const isTouched = shallowRef(false)
  const wasSubmitted = shallowRef(false)
  const fieldError = computed(() => {
    if (value.value.trim()) return undefined
    return isTouched.value || wasSubmitted.value ? t(messageKey) : undefined
  })

  function markFieldTouched() {
    isTouched.value = true
  }

  function validateFieldBeforeSubmit() {
    isTouched.value = true
    wasSubmitted.value = true
    return !fieldError.value
  }

  return {
    fieldError,
    markFieldTouched,
    validateFieldBeforeSubmit
  }
}
